import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RouteShareService } from '../../../../../../shared/services/route-share.service';
import { firstValueFrom } from 'rxjs';
import { Document, DocumentChunk } from '@reflact/docsearch';

export type DocSearchResultItem = { document: Document, chunk: DocumentChunk & { vs_score: number, chapterPath?: string } }
export type DocSearchResult = { searchResults: DocSearchResultItem[], status: string }
@Injectable({
  providedIn: 'root'
})
export class SearchTestService {

  public searchTestIsRunning: boolean = false;
  public searchTestResults: DocSearchResultItem[] = [];
  public searchTestCompleted: boolean = false;

  constructor(public httpClient: HttpClient, private rss: RouteShareService) { }

  public resetSearchTest() {
    this.searchTestResults = [];
    this.searchTestCompleted = false;
  }
  public async searchTest(phrase: string) {
    const docId = this.rss.document?._id ?? "";
    if (docId != "") {
      this.searchTestIsRunning = true;
      this.searchTestCompleted = false;
      const botId = this.rss.botConfig._id;
      const result = await firstValueFrom(this.httpClient.post<DocSearchResult>(`/api/toolbox/bot/admin/botdoc/searchtest/${botId}/${docId}`, { phrase }));
      this.searchTestResults = result.searchResults;
      this.searchTestCompleted = true;
      this.searchTestIsRunning = false;
    }
  }

}
